module.exports = __webpack_public_path__ + "media/venue/meetups@2x-49b40307.png";